import React, { useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { FaKey } from 'react-icons/fa'
import Cookies from 'js-cookie'
import axios from 'axios'
import { theme } from '../theme/theme'
import CustomBtn from '../common/CustomBtn'
import { BASE_URL } from '../constants'


const ChangePassword = () => {
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showCurrentPassword, setShowCurrentPassword] = useState(false)
  const [changePassword, setChangePassword] = useState({
    current_password: '',
    new_password: '',
    new_password_confirmation: '',
  })

  const handleChange = (e) => {
    console.log(`Field changed: ${e.target.name}, New Value: ${e.target.value}`)
    setChangePassword({ ...changePassword, [e.target.name]: e.target.value }) // Corrected state update
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault()
    console.log('Form submission started.')
    console.log('Current user data:', changePassword)

    const token = Cookies.get('authToken')
    console.log('Auth Token: ', token)

    const payload = {
      current_password: changePassword.current_password,
      new_password: changePassword.new_password,
      new_password_confirmation: changePassword.new_password_confirmation,
    }

    try {
      const result = await axios.post(
        BASE_URL+'/update/password',
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      )
      toast.success(result.data.message)
    } catch (error) {
      const errorMessage =
        error.response?.data.message ||
        error.message ||
        'Failed to change password'
      console.log('Error during password update', errorMessage)
      toast.error(errorMessage)
    }
  }

  return (
      <Container className="pb-3" style={{fontFamily: theme.font.family }}>
      <div
        className="d-flex justify-content-center"
        style={{ paddingTop: '2rem' }}
      >
        <div
          className="card p-4 shadow-lg"
          style={{ width: '100%', maxWidth: '500px', border: 'none' }}
        >
          <form>

                      <p className="mb-4 fw-bold" style={{ color: theme.colors.primary, borderBottom: '2px solid #ccc', paddingBottom: '8px' , fontSize: '1.5rem'}}>
                        Change Password <FaKey />
                        </p>
            <Row className="mb-3">
              <Col className="text-start">
                Current Password
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <i className="fa fa-lock"></i>
                  </span>
                  <input
                    type={showCurrentPassword ? 'text' : 'password'}
                    className="form-control"
                    name="current_password"
                    placeholder="Enter Your Current Password"
                    onChange={handleChange}
                    value={changePassword.current_password}
                    required
                  />
                  <span
                    className="input-group-text bg-white"
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                    style={{ cursor: 'pointer' }}
                  >
                    <i
                      className={`fa ${
                        showCurrentPassword ? 'fa-eye-slash' : 'fa-eye'
                      }`}
                    ></i>
                  </span>
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col className="text-start">
                New Password
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <i className="fa fa-lock"></i>
                  </span>
                  <input
                    type={showNewPassword ? 'text' : 'password'}
                    className="form-control"
                    name="new_password"
                    placeholder="Enter Your New Password"
                    onChange={handleChange}
                    value={changePassword.new_password}
                    required
                  />
                  <span
                    className="input-group-text bg-white"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    style={{ cursor: 'pointer' }}
                  >
                    <i
                      className={`fa ${
                        showNewPassword ? 'fa-eye-slash' : 'fa-eye'
                      }`}
                    ></i>
                  </span>
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col className="text-start">
                Re-Enter Password
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <i className="fa fa-lock"></i>
                  </span>
                  <input
                    className="form-control"
                    type="password"
                    name="new_password_confirmation"
                    placeholder="Re-Enter Your Password"
                    onChange={handleChange}
                    value={changePassword.new_password_confirmation}
                    required
                  />
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col style={{ marginTop: '1rem' }}>
                <Button
                  type="submit"
              
                  onClick={handleFormSubmit}
                  style={{
                    color: theme.colors.background,
                    width: '100%',
                    fontWeight: 'bold',
                    border: 'none',
                    backgroundColor: theme.colors.primary,
                  }}
                >
                  Change Password
                </Button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </Container>
  )
}

export default ChangePassword
